/* eslint-disable */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import client from 'index.js';
import { apiUrl } from 'App.js';

const channelNameDict = { 1: 'amazon', 2: 'rakuten', 3: 'yahoo' };

export const fetchRegisterDiagnosisProduct = createAsyncThunk(
  'performancereview/register',
  async (arg, thunkAPI) => {
    const { accountId, plan } = thunkAPI.getState().user;
    const { channel, channelName } = thunkAPI.getState().currentchannel;
    const { item_id, shop_code, shop_name, section } = arg;
    const res = await client.post(`${apiUrl}performance_review/register`, {
      accountId: accountId,
      channel: channel,
      itemId: item_id,
      shopCode: shop_code,
      shopName: shop_name,
      section: section,
      premium: plan[channelName].premium
    });
    return res.data;
  }
);

export const fetchDiagnosisProductList = createAsyncThunk(
  'performancereview/get_item',
  async (arg, thunkAPI) => {
    const { accountId, plan } = thunkAPI.getState().user;
    const { channel, channelName } = thunkAPI.getState().currentchannel;
    const { section } = arg;
    const res = await client.post(`${apiUrl}performance_review/get_item_list`, {
      accountId: accountId,
      channel: channel,
      section: section,
      premium: plan[channelName].premium
    });
    return res.data;
  }
);

export const fetchDiagnosisProductDelete = createAsyncThunk(
  'performancereview/delete_item',
  async (arg, thunkAPI) => {
    const { accountId } = thunkAPI.getState().user;
    const { id } = arg;
    const res = await client.post(`${apiUrl}performance_review/delete_item`, {
      accountId: accountId,
      id: id
    });
    return res.data;
  }
);

export const fetchReviewReport = createAsyncThunk(
  'performancereview/get_item_report',
  async (arg, thunkAPI) => {
    const { channel } = thunkAPI.getState().currentchannel;
    const { term, improvementsOrder } = thunkAPI.getState().performancereview;
    const { item_id, shop_code, section, firstdayFlag } = arg;
    const res = await client.post(
      `${apiUrl}performance_review/get_item_report`,
      {
        channel: channel,
        itemId: item_id,
        shopCode: shop_code,
        section: section,
        term: term,
        order: improvementsOrder,
        firstDayFlag: firstdayFlag
      }
    );
    return res.data;
  }
);

export const fetchReviewReportChangeTerm = createAsyncThunk(
  'performancereview/get_item_report/change_term',
  async (arg, thunkAPI) => {
    const { term, amazon, rakuten, improvementsOrder } =
      thunkAPI.getState().performancereview;
    const { section, channel } = arg;
    let item_id = '';
    let shop_code = '';
    let firstDayFlag = 0;
    if ((section == 'own') & (channel == 1)) {
      item_id = amazon.ownItemData.itemId.split(':')[1];
      shop_code = amazon.ownItemData.itemId.split(':')[0];
      firstDayFlag = amazon.ownItemData.firstday_flag;
    } else if ((section == 'other') & (channel == 1)) {
      item_id = amazon.otherItemData.itemId.split(':')[1];
      shop_code = amazon.otherItemData.itemId.split(':')[0];
      firstDayFlag = amazon.otherItemData.firstday_flag;
    } else if ((section == 'own') & (channel == 2)) {
      if (rakuten.ownItemData.itemId == '') {
        item_id = '';
        shop_code = '';
        firstDayFlag = rakuten.ownItemData.firstday_flag;
      } else {
        item_id = rakuten.ownItemData.itemId.split(':')[1];
        shop_code = rakuten.ownItemData.itemId.split(':')[0];
        firstDayFlag = rakuten.ownItemData.firstday_flag;
      }
    } else if ((section == 'other') & (channel == 2)) {
      if (rakuten.otherItemData.itemId == '') {
        item_id = '';
        shop_code = '';
        firstDayFlag = rakuten.otherItemData.firstday_flag;
      } else {
        item_id = rakuten.otherItemData.itemId.split(':')[1];
        shop_code = rakuten.otherItemData.itemId.split(':')[0];
        firstDayFlag = rakuten.otherItemData.firstday_flag;
      }
    }
    const res = await client.post(
      `${apiUrl}performance_review/get_item_report`,
      {
        channel: channel,
        itemId: item_id,
        shopCode: shop_code,
        section: section,
        term: term,
        order: improvementsOrder,
        firstDayFlag: firstDayFlag
      }
    );
    return res.data;
  }
);

export const fetchReviewReportChangeOrder = createAsyncThunk(
  'performancereview/get_item_report/change_order',
  async (arg, thunkAPI) => {
    const { channel } = thunkAPI.getState().currentchannel;
    const { amazon, rakuten, improvementsOrder } =
      thunkAPI.getState().performancereview;
    let improvements;
    if (channel == 1) {
      improvements = amazon.ownItemData.improvements;
    } else if (channel == 2) {
      improvements = rakuten.ownItemData.improvements;
    }
    const res = await client.post(
      `${apiUrl}performance_review/change_improvements_order`,
      {
        improvements: improvements,
        order: improvementsOrder,
        channel: channel
      }
    );
    return res.data;
  }
);

export const fetchAmazonSellerList = createAsyncThunk(
  'performancereview/get_amazon_seller',
  async (arg, thunkAPI) => {
    const { item_id } = arg;
    const res = await client.post(`${apiUrl}performance_review/amazon_seller`, {
      item_id: item_id
    });
    return res.data;
  }
);

export const fetchKeywordList = createAsyncThunk(
  'performancereview/get_seo_keyword',
  async (compareType, thunkAPI) => {
    const { accountId, plan } = thunkAPI.getState().user;
    const { channel, channelName } = thunkAPI.getState().currentchannel;
    const { amazon, rakuten, seoSetting } =
      thunkAPI.getState().performancereview;
    let item_id = '';
    if (channel == 1 && amazon.ownItemData.itemId && compareType == 'own') {
      item_id = amazon.ownItemData.itemId;
    } else if (
      channel == 1 &&
      amazon.otherItemData.itemId &&
      compareType == 'other'
    ) {
      item_id = amazon.otherItemData.itemId;
    } else if (
      channel == 2 &&
      rakuten.ownItemData.itemId &&
      compareType == 'own'
    ) {
      item_id = rakuten.ownItemData.itemId;
    } else if (
      channel == 2 &&
      rakuten.otherItemData.itemId &&
      compareType == 'other'
    ) {
      item_id = rakuten.otherItemData.itemId;
    }
    if (!item_id) {
      return thunkAPI.rejectWithValue({
        error: 'item_id is missing',
        compareType
      });
    }
    const res = await client.post(
      `${apiUrl}performance_review/get_seo_keyword`,
      {
        type: seoSetting.keywordType,
        channel,
        account_id: accountId,
        item_id,
        premium: plan[channelName].premium
      }
    );
    return {
      data: res.data,
      compareType
    };
  }
);

export const fetchKeywordGraph = createAsyncThunk(
  'performancereview/get_seo_graph',
  async (compareType, thunkAPI) => {
    const { accountId } = thunkAPI.getState().user;
    const { channel } = thunkAPI.getState().currentchannel;
    const { amazon, rakuten, term, seoSetting } =
      thunkAPI.getState().performancereview;
    let item_id = '';
    if (channel == 1 && amazon.ownItemData.itemId && compareType == 'own') {
      item_id = amazon.ownItemData.itemId;
    } else if (
      channel == 1 &&
      amazon.otherItemData.itemId &&
      compareType == 'other'
    ) {
      item_id = amazon.otherItemData.itemId;
    } else if (
      channel == 2 &&
      rakuten.ownItemData.itemId &&
      compareType == 'own'
    ) {
      item_id = rakuten.ownItemData.itemId;
    } else if (
      channel == 2 &&
      rakuten.otherItemData.itemId &&
      compareType == 'other'
    ) {
      item_id = rakuten.otherItemData.itemId;
    }
    if (!item_id) {
      return thunkAPI.rejectWithValue({
        error: 'item_id is missing',
        compareType
      });
    }
    let keyword;
    if (compareType == 'own') {
      keyword = seoSetting.ownKeyword;
    } else {
      keyword = seoSetting.otherKeyword;
    }
    try {
      const res = await client.post(
        `${apiUrl}performance_review/get_seo_graph`,
        {
          type: seoSetting.keywordType,
          channel,
          account_id: accountId,
          item_id,
          keyword: keyword,
          term
        }
      );
      return {
        data: res.data,
        compareType
      };
    } catch (error) {
      // rejected の場合にも compareType を返す
      return thunkAPI.rejectWithValue({
        error: error.message,
        compareType
      });
    }
  }
);

export const fetchRegisterSeoKeyword = createAsyncThunk(
  'performancereview/register_seo_keyword',
  async (arg, thunkAPI) => {
    const { accountId, plan } = thunkAPI.getState().user;
    const { channel, channelName } = thunkAPI.getState().currentchannel;
    const { amazon, rakuten, seoSetting } =
      thunkAPI.getState().performancereview;
    const { keyword, compareType } = arg;
    let item_id;
    if (channel == 1 && compareType == 'own') {
      item_id = amazon.ownItemData.itemId;
    } else if (channel == 1 && compareType == 'other') {
      item_id = amazon.otherItemData.itemId;
    } else if (channel == 2 && compareType == 'own') {
      item_id = rakuten.ownItemData.itemId;
    } else if (channel == 2 && compareType == 'other') {
      item_id = rakuten.otherItemData.itemId;
    }
    const res = await client.post(
      `${apiUrl}performance_review/register_seo_keyword`,
      {
        type: seoSetting.keywordType,
        channel,
        account_id: accountId,
        item_id,
        keyword: keyword,
        premium: plan[channelName].premium
      }
    );
    return res.data;
  }
);

export const fetchDeleteSeoKeyword = createAsyncThunk(
  'performancereview/delete_seo_keyword',
  async (compareType, thunkAPI) => {
    const { accountId } = thunkAPI.getState().user;
    const { channel } = thunkAPI.getState().currentchannel;
    const { amazon, rakuten, seoSetting } =
      thunkAPI.getState().performancereview;
    let keyword;
    let item_id;
    if (channel == 1 && compareType == 'own') {
      item_id = amazon.ownItemData.itemId;
      keyword = seoSetting.ownKeyword;
    } else if (channel == 1 && compareType == 'other') {
      item_id = amazon.otherItemData.itemId;
      keyword = seoSetting.otherKeyword;
    } else if (channel == 2 && compareType == 'own') {
      item_id = rakuten.ownItemData.itemId;
      keyword = seoSetting.ownKeyword;
    } else if (channel == 2 && compareType == 'other') {
      item_id = rakuten.otherItemData.itemId;
      keyword = seoSetting.otherKeyword;
    }
    const res = await client.post(
      `${apiUrl}performance_review/delete_seo_keyword`,
      {
        type: seoSetting.keywordType,
        channel,
        account_id: accountId,
        item_id,
        keyword: keyword
      }
    );
    return res.data;
  }
);

const getCurrentMonth = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
};

const getPastMonths = (numMonths) => {
  const months = [];
  const now = new Date();
  for (let i = 0; i < numMonths; i++) {
    const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
    months.push(
      `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`
    );
  }
  return months.reverse();
};

const performancereviewSlice = createSlice({
  name: 'newMeasureAnalysis',
  initialState: {
    term: getCurrentMonth(),
    termList: ['', ...getPastMonths(3)],
    amazon: {
      ownItemData: {
        itemName: '',
        itemId: '',
        score: '',
        categoryName: '',
        price: 0,
        categoryTop5Price: 0,
        description: '',
        imgList: [],
        aveRank: 0,
        reviewScore: 0,
        reviewNum: 0,
        graphData: [],
        trackingData: [
          { category: '総合評価', scores: [] },
          { category: '平均ランキング', scores: [] },
          { category: '集客施策', scores: [] },
          { category: '検索', scores: [] },
          { category: '価格', scores: [] },
          { category: '商品ページ', scores: [] },
          { category: '出品', scores: [] },
          { category: 'ストア', scores: [] }
        ],
        reviewResult: [],
        selectItemFlag: false,
        improvements: [],
        firstday_flag: 0,
        click_supported_flag: ''
      },
      otherItemData: {
        itemName: '',
        itemId: '',
        score: '',
        categoryName: '',
        price: 0,
        description: '',
        imgList: [],
        aveRank: 0,
        reviewScore: 0,
        reviewNum: 0,
        graphData: [],
        trackingData: [
          { category: '総合評価', scores: [] },
          { category: '平均ランキング', scores: [] },
          { category: '集客施策', scores: [] },
          { category: '検索', scores: [] },
          { category: '価格', scores: [] },
          { category: '商品ページ', scores: [] },
          { category: '出品', scores: [] },
          { category: 'ストア', scores: [] }
        ],
        reviewResult: [],
        selectItemFlag: false
      },
      sellerList: [],
      selectedSeller: '',
      firstday_flag: 0
    },
    rakuten: {
      ownItemData: {
        itemName: '',
        itemId: '',
        score: '',
        categoryName: '',
        price: 0,
        categoryTop5Price: 0,
        aveRank: 0,
        reviewScore: 0,
        reviewNum: 0,
        graphData: [],
        trackingData: [
          { category: '総合評価', scores: [] },
          { category: '平均ランキング', scores: [] },
          { category: '集客施策', scores: [] },
          { category: '検索', scores: [] },
          { category: '価格', scores: [] },
          { category: '商品ページ', scores: [] },
          { category: '出品', scores: [] },
          { category: 'ストア', scores: [] }
        ],
        reviewResult: [],
        improvements: [],
        firstday_flag: 0,
        selectItemFlag: false
      },
      otherItemData: {
        itemName: '',
        itemId: '',
        score: '',
        categoryName: '',
        price: 0,
        aveRank: 0,
        reviewScore: 0,
        reviewNum: 0,
        graphData: [],
        trackingData: [
          { category: '総合評価', scores: [] },
          { category: '平均ランキング', scores: [] },
          { category: '集客施策', scores: [] },
          { category: '検索', scores: [] },
          { category: '価格', scores: [] },
          { category: '商品ページ', scores: [] },
          { category: '出品', scores: [] },
          { category: 'ストア', scores: [] }
        ],
        reviewResult: [],
        firstday_flag: 0,
        selectItemFlag: false
      }
    },
    ownItemList: [],
    otherItemList: [],
    ownDataLoading: false,
    otherDataLoading: false,
    registerLoading: false,
    improvementsOrder: 'high',
    improvementsLoading: false,
    sellerLoading: false,
    modalOpen: { index: 0, open: false, detailsIndex: 0 },
    keywordList: {
      ownKeywordList: [],
      otherKeywordList: [],
      ownLoading: false,
      otherLoading: false
    },
    seoSetting: {
      compareType: 'own',
      seoType: 'organic',
      keywordType: 'specific',
      ownKeyword: '',
      otherKeyword: ''
    },
    seoGraphData: {
      own: {
        organic: [],
        sponsor: [],
        organicRank: 0,
        sponsorRank: 0,
        loading: false
      },
      other: {
        organic: [],
        sponsor: [],
        organicRank: 0,
        sponsorRank: 0,
        loading: false
      },
      yokoziku: []
    },
    seoLoading: false
  },
  reducers: {
    changePerformanceTerm(state, action) {
      state.term = action.payload;
    },
    changePerformanceTermList(state, action) {
      state.termList = action.payload;
    },
    setPriorityOrder(state, action) {
      state.improvementsOrder = action.payload;
    },
    setSellerInfo(state, action) {
      state.amazon.selectedSeller = action.payload;
    },
    setPerformanceModalOpen(state, action) {
      state.modalOpen = action.payload;
    },
    setCompareType(state, action) {
      state.seoSetting.compareType = action.payload;
    },
    setWordType(state, action) {
      //指名:specific or 一般：general
      state.seoSetting.keywordType = action.payload;
    },
    setSeoType(state, action) {
      //オーガニック：organic 広告:sponsor
      state.seoSetting.seoType = action.payload;
    },
    setKeyword(state, action) {
      const { value, compareType } = action.payload;
      if (compareType == 'own') {
        state.seoSetting.ownKeyword = value;
      } else {
        state.seoSetting.otherKeyword = value;
      }
    },
    resetSeoData(state, action) {
      state.seoSetting = {
        // compareType: 'own',
        keywordType: 'specific',
        keyword: ''
      };
      state.seoGraphData = {
        own: {
          organic: [],
          sponsor: [],
          organicRank: 0,
          sponsorRank: 0
        },
        other: {
          organic: [],
          sponsor: [],
          organicRank: 0,
          sponsorRank: 0
        },
        yokoziku: []
      };
    },
    resetKeyword(state, action) {
      state.seoSetting.ownKeyword = '';
      state.seoSetting.otherKeyword = '';
      state.seoGraphData = {
        own: {
          organic: [],
          sponsor: [],
          organicRank: 0,
          sponsorRank: 0,
          loading: false
        },
        other: {
          organic: [],
          sponsor: [],
          organicRank: 0,
          sponsorRank: 0,
          loading: false
        },
        yokoziku: []
      };
    }
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchRegisterDiagnosisProduct.fulfilled,
      (state, action) => {
        return {
          ...state,
          registerLoading: false
        };
      }
    );
    builder.addCase(fetchRegisterDiagnosisProduct.pending, (state, action) => {
      return {
        ...state,
        registerLoading: true
      };
    });
    builder.addCase(fetchRegisterDiagnosisProduct.rejected, (state, action) => {
      return {
        ...state,
        registerLoading: false
      };
    });
    builder.addCase(fetchDiagnosisProductList.fulfilled, (state, action) => {
      if (action.payload.section == 1) {
        return {
          ...state,
          ownItemList: action.payload.data,
          registerLoading: false
        };
      } else if (action.payload.section == 2) {
        return {
          ...state,
          otherItemList: action.payload.data,
          registerLoading: false
        };
      }
    });
    builder.addCase(fetchDiagnosisProductList.pending, (state, action) => {
      return {
        ...state,
        registerLoading: true
      };
    });
    builder.addCase(fetchDiagnosisProductList.rejected, (state, action) => {
      return {
        ...state,
        registerLoading: false
      };
    });
    builder.addCase(fetchReviewReport.fulfilled, (state, action) => {
      const { section, channel, data } = action.payload;

      const platform = channelNameDict[channel];
      if (!platform) return; // 想定外のチャネルなら何もしない

      const targetKey = section === 'own' ? 'ownItemData' : 'otherItemData';
      const loadingKey =
        section === 'own' ? 'ownDataLoading' : 'otherDataLoading';

      return {
        ...state,
        [platform]: {
          ...state[platform],
          [targetKey]: {
            ...state[platform][targetKey], // 既存データ
            ...data, // 新しいデータ（上書き）
            selectItemFlag: true // 追加キー
          }
        },
        [loadingKey]: false
      };
    });
    builder
      .addCase(fetchReviewReport.pending, (state, action) => {
        const { section } = action.meta.arg;
        return {
          ...state,
          otherDataLoading: section === 'other' ? true : state.otherDataLoading,
          ownDataLoading: section === 'own' ? true : state.ownDataLoading
        };
      })
      .addCase(fetchReviewReport.rejected, (state, action) => {
        const { section, channel } = action.meta.arg ?? {};

        const platform = channelNameDict[channel];
        if (!platform) return;

        const targetKey = section === 'own' ? 'ownItemData' : 'otherItemData';
        const loadingKey =
          section === 'own' ? 'ownDataLoading' : 'otherDataLoading';

        return {
          ...state,
          [platform]: {
            ...state[platform],
            [targetKey]: {
              ...state[platform][targetKey],
              selectItemFlag: false
            }
          },
          [loadingKey]: false
        };
      });
    builder.addCase(fetchReviewReportChangeTerm.fulfilled, (state, action) => {
      const { section, channel, data } = action.payload;
      const platform = channelNameDict[channel];
      if (!platform) return; // 想定外のチャネルなら何もしない

      const targetKey = section === 'own' ? 'ownItemData' : 'otherItemData';
      const loadingKey =
        section === 'own' ? 'ownDataLoading' : 'otherDataLoading';

      return {
        ...state,
        [platform]: {
          ...state[platform],
          [targetKey]: {
            ...state[platform][targetKey],
            ...data,
            selectItemFlag: true
          }
        },
        [loadingKey]: false
      };
    });
    builder.addCase(fetchReviewReportChangeTerm.pending, (state, action) => {
      const { section } = action.meta.arg;
      return {
        ...state,
        otherDataLoading: section === 'other' ? true : state.otherDataLoading,
        ownDataLoading: section === 'own' ? true : state.ownDataLoading
      };
    });
    builder.addCase(fetchReviewReportChangeTerm.rejected, (state, action) => {
      const { section, channel } = action.meta.arg ?? {};

      const platform = channelNameDict[channel];
      if (!platform) return;

      const targetKey = section === 'own' ? 'ownItemData' : 'otherItemData';
      const loadingKey =
        section === 'own' ? 'ownDataLoading' : 'otherDataLoading';

      return {
        ...state,
        [platform]: {
          ...state[platform],
          [targetKey]: {
            ...state[platform][targetKey],
            selectItemFlag: false
          }
        },
        [loadingKey]: false
      };
    });
    builder.addCase(fetchReviewReportChangeOrder.fulfilled, (state, action) => {
      if (action.payload.channel == 1) {
        return {
          ...state,
          amazon: {
            ...state.amazon,
            ownItemData: {
              ...state.amazon.ownItemData,
              improvements: action.payload.data
            }
          },
          improvementsLoading: false
        };
      } else if (action.payload.channel == 2) {
        return {
          ...state,
          rakuten: {
            ...state.rakuten,
            ownItemData: {
              ...state.rakuten.ownItemData,
              improvements: action.payload.data
            }
          },
          improvementsLoading: false
        };
      }
    });
    builder.addCase(fetchReviewReportChangeOrder.pending, (state, action) => {
      return {
        ...state,
        improvementsLoading: true
      };
    });
    builder.addCase(fetchReviewReportChangeOrder.rejected, (state, action) => {
      return {
        ...state,
        improvementsLoading: false
      };
    });
    builder.addCase(fetchAmazonSellerList.fulfilled, (state, action) => {
      return {
        ...state,
        amazon: {
          ...state.amazon,
          sellerList: action.payload.seller_list
        },
        sellerLoading: false
      };
    });
    builder.addCase(fetchAmazonSellerList.pending, (state, action) => {
      return {
        ...state,
        sellerLoading: true
      };
    });
    builder.addCase(fetchAmazonSellerList.rejected, (state, action) => {
      return {
        ...state,
        sellerLoading: false
      };
    });
    builder.addCase(fetchKeywordList.fulfilled, (state, action) => {
      const { data, compareType } = action.payload;
      if (compareType == 'own') {
        return {
          ...state,
          keywordList: {
            ...state.keywordList,
            ownKeywordList: data.data,
            ownLoading: false
          }
        };
      }
      if (compareType == 'other') {
        return {
          ...state,
          keywordList: {
            ...state.keywordList,
            otherKeywordList: data.data,
            otherLoading: false
          }
        };
      }
    });
    builder.addCase(fetchKeywordList.pending, (state, action) => {
      const compareType = action.meta.arg;
      if (compareType == 'own') {
        return {
          ...state,
          keywordList: {
            ...state.keywordList,
            ownLoading: true
          }
        };
      }
      if (compareType == 'other') {
        return {
          ...state,
          keywordList: {
            ...state.keywordList,
            otherLoading: true
          }
        };
      }
    });
    builder.addCase(fetchKeywordList.rejected, (state, action) => {
      const { compareType } = action.payload;
      if (compareType == 'own') {
        return {
          ...state,
          keywordList: {
            ...state.keywordList,
            ownLoading: false
          }
        };
      }
      if (compareType == 'other') {
        return {
          ...state,
          keywordList: {
            ...state.keywordList,
            otherLoading: false
          }
        };
      }
    });
    builder.addCase(fetchKeywordGraph.fulfilled, (state, action) => {
      const { data, compareType } = action.payload;
      if (compareType === 'own') {
        state.seoGraphData.own.organic = data.organic;
        state.seoGraphData.own.sponsor = data.sponsor;
        state.seoGraphData.own.organicRank = data.organicRank;
        state.seoGraphData.own.sponsorRank = data.sponsorRank;
        state.seoGraphData.own.loading = false;
      } else if (compareType === 'other') {
        state.seoGraphData.other.organic = data.organic;
        state.seoGraphData.other.sponsor = data.sponsor;
        state.seoGraphData.other.organicRank = data.organicRank;
        state.seoGraphData.other.sponsorRank = data.sponsorRank;
        state.seoGraphData.other.loading = false;
      }

      state.seoGraphData.yokoziku = data.yokoziku;
      state.seoLoading = false;
    });
    builder.addCase(fetchKeywordGraph.pending, (state, action) => {
      const compareType = action.meta.arg;
      if (compareType === 'own') {
        state.seoGraphData.own.loading = true;
      } else if (compareType === 'other') {
        state.seoGraphData.other.loading = true;
      }
    });
    builder.addCase(fetchKeywordGraph.rejected, (state, action) => {
      const compareType = action.payload?.compareType;
      if (compareType === 'own') {
        state.seoGraphData.own.loading = false;
      } else if (compareType === 'other') {
        state.seoGraphData.other.loading = false;
      }
    });
    builder.addCase(fetchRegisterSeoKeyword.fulfilled, (state, action) => {
      return {
        ...state,
        seoLoading: false
      };
    });
    builder.addCase(fetchRegisterSeoKeyword.pending, (state, action) => {
      return {
        ...state,
        seoLoading: true
      };
    });
    builder.addCase(fetchRegisterSeoKeyword.rejected, (state, action) => {
      return {
        ...state,
        seoLoading: false
      };
    });
    builder.addCase(fetchDeleteSeoKeyword.fulfilled, (state, action) => {
      return {
        ...state,
        seoLoading: false
      };
    });
    builder.addCase(fetchDeleteSeoKeyword.pending, (state, action) => {
      return {
        ...state,
        seoLoading: true
      };
    });
    builder.addCase(fetchDeleteSeoKeyword.rejected, (state, action) => {
      return {
        ...state,
        seoLoading: false
      };
    });
  }
});

export const {
  changePerformanceTerm,
  changePerformanceTermList,
  setPriorityOrder,
  setSellerInfo,
  setPerformanceModalOpen,
  setCompareType,
  setKeyword,
  setWordType,
  setSeoType,
  resetSeoData,
  resetKeyword
} = performancereviewSlice.actions;
export const performancereviewTermList = (state) =>
  state.performancereview.termList;
export const performancereviewOwnDataLoading = (state) =>
  state.performancereview.ownDataLoading;
export const performancereviewOtherDataLoading = (state) =>
  state.performancereview.otherDataLoading;
export const performancereviewRegisterLoading = (state) =>
  state.performancereview.registerLoading;
export const performancereviewItemDatas = (state) => state.performancereview;
export const performancereviewAmazonOwnItemData = (state) =>
  state.performancereview.amazon.ownItemData;
export const performancereviewRakutenOwnItemData = (state) =>
  state.performancereview.rakuten.ownItemData;
export const performancereviewAmazonOwnGraphData = (state) =>
  state.performancereview.amazon.ownItemData.graphData;
export const performancereviewRakutenOwnGraphData = (state) =>
  state.performancereview.rakuten.ownItemData.graphData;
export const performancereviewAmazonOwnTrackingData = (state) =>
  state.performancereview.amazon.ownItemData.trackingData;
export const performancereviewRakutenOwnTrackingData = (state) =>
  state.performancereview.rakuten.ownItemData.trackingData;
export const performancereviewAmazonOwnReviewResult = (state) =>
  state.performancereview.amazon.ownItemData.reviewResult;
export const performancereviewRakutenOwnReviewResult = (state) =>
  state.performancereview.rakuten.ownItemData.reviewResult;
export const performancereviewAmazonOwnImprovements = (state) =>
  state.performancereview.amazon.ownItemData.improvements;
export const performancereviewRakutenOwnImprovements = (state) =>
  state.performancereview.rakuten.ownItemData.improvements;
export const performancereviewAmazonOtherItemData = (state) =>
  state.performancereview.amazon.otherItemData;
export const performancereviewRakutenOtherItemData = (state) =>
  state.performancereview.rakuten.otherItemData;
export const performancereviewAmazonOtherGraphData = (state) =>
  state.performancereview.amazon.otherItemData.graphData;
export const performancereviewRakutenOtherGraphData = (state) =>
  state.performancereview.rakuten.otherItemData.graphData;
export const performancereviewAmazonOtherTrackingData = (state) =>
  state.performancereview.amazon.otherItemData.trackingData;
export const performancereviewRakutenOtherTrackingData = (state) =>
  state.performancereview.rakuten.otherItemData.trackingData;
export const performancereviewAmazonOtherReviewResult = (state) =>
  state.performancereview.amazon.otherItemData.reviewResult;
export const performancereviewRakutenOtherReviewResult = (state) =>
  state.performancereview.rakuten.otherItemData.reviewResult;
export const performancereviewOwnItemList = (state) =>
  state.performancereview.ownItemList;
export const performancereviewOtherItemList = (state) =>
  state.performancereview.otherItemList;
export const performancereviewTerm = (state) => state.performancereview.term;
export const performancereviewOrder = (state) =>
  state.performancereview.improvementsOrder;
export const performancereviewOrderLoading = (state) =>
  state.performancereview.improvementsLoading;
export const sellerList = (state) => state.performancereview.amazon.sellerList;
export const sellerLoading = (state) => state.performancereview.sellerLoading;
export const selectedSellerInfo = (state) =>
  state.performancereview.amazon.selectedSeller;
export const performancereviewAmazonOwnScore = (state) =>
  state.performancereview.amazon.ownItemData.score;
export const performancereviewAmazonOtherScore = (state) =>
  state.performancereview.amazon.otherItemData.score;
export const performancereviewRakutenOwnScore = (state) =>
  state.performancereview.rakuten.ownItemData.score;
export const performancereviewRakutenOtherScore = (state) =>
  state.performancereview.rakuten.otherItemData.score;
export const performanceModalOpen = (state) =>
  state.performancereview.modalOpen;
export const performanceSeoLoading = (state) =>
  state.performancereview.seoLoading;
export const performanceSeoData = (state) =>
  state.performancereview.seoGraphData;
export const performanceSeokeywordList = (state) =>
  state.performancereview.keywordList;
export const performanceSeoSetting = (state) =>
  state.performancereview.seoSetting;

export default performancereviewSlice.reducer;
